var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{on:{"mouseleave":function($event){_vm.showEdit = false},"mousemove":function($event){_vm.showEdit = true}}},[_c('el-link',{on:{"click":_vm.editTag}},[_vm._v(_vm._s(_vm.data))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }